import {
    Component,
    OnInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    ViewChild,
    AfterViewInit,
    Inject,
    QueryList,
    Input,
    ElementRef, ViewChildren, OnDestroy
} from '@angular/core';
import {forkJoin, Observable, Observer, Subscription} from 'rxjs';
import {BsModalService, BsModalRef} from 'ngx-bootstrap';
import {SwalComponent} from '@toverux/ngx-sweetalert2';

import {UsersService} from 'src/app/modules/shared/services/users.service';
import {CalculationsViewModel} from 'src/app/modules/shared/viewModels/calculations.viewModel';
import {DailyMealViewModel} from 'src/app/modules/shared/viewModels/dailyMeal.viewModel';
import {BsModalEventsEmitter} from 'src/app/modules/shared/events/bsModal.events';
import {DiaryService} from '../../../shared/services/diary.service';
import {DiaryChatMessage, DiaryViewModel} from '../../../shared/viewModels/diary.viewModel';
import {RecipeViewModel} from '../../../shared/viewModels/recipe.viewModel';
import {MealViewModel} from '../../../shared/viewModels/meal.viewModel';
import {CateringUserViewModel, DietViewModel} from 'src/app/modules/shared/viewModels/diet.viewModel';
import {CreateDiaryDTO} from '../../../shared/dto/createDiary.dto';
import {LocalisationService} from 'src/app/modules/shared/services/localisation.service';
import {DiaryRecipeViewModel} from 'src/app/modules/shared/viewModels/diaryRecipe.viewModel';
import {ViewRecipeComponent} from '../modals/view-recipe/view-recipe.component';
import {DateService} from 'src/app/modules/shared/services/date.service';
import {SWIPER_CONFIG, SwiperConfigInterface} from 'ngx-swiper-wrapper';
import {AddRecipeModalComponent} from '../modals/add-recipe/add-recipe.component';
import {StorageService} from '../../../shared/services/storage.service';
import {AppLoadingEventsEmitter} from '../../../shared/events/loading.events';
import {UserProfileViewModel} from '../../../shared/viewModels/userProfile.viewModel';
import {ShoppingListComponent} from '../modals/shopping-list/shopping-list.component';
import {ExternalMealsComponent} from '../modals/external-meals/external-meals.component';
import {ExternalMealViewModel} from '../viewModels/externalMeal.viewModel';
import * as moment from 'moment';
import {NgbTooltip} from '@ng-bootstrap/ng-bootstrap';
import {ProductNutrientViewModel} from '../../../shared/viewModels/productNutrient.viewModel';
import {DiaryNutrientViewModel} from '../../../shared/viewModels/diaryNutrient.viewModel';
import {ProductsService} from '../../../shared/services/products.service';
import {Constants} from '../../../shared/config/constants.config';
import {ThemeService} from '../../../shared/services/theme.service';
import {PricingService} from '../../../pricing/services/pricing.service';
import {UpgradeComponent} from '../../../shared/components/modals/upgrade/upgrade.component';
import {Router} from '@angular/router';
import {CopyRecipeComponent} from '../modals/copy-recipe/copy-recipe.component';
import {DatepickerComponent} from '../../../shared/components/common/datepicker/datepicker.component';
import {DiaryTrainingComponent} from '../modals/diary-training/diary-training.component';
import {DailyChangesActivitiesComponent} from '../modals/daily-changes-activities/daily-changes-activities.component';
import {TriggerActionEventsEmitter} from '../../../shared/events/triggerAction.events';
import {TriggerActionDto} from '../../../shared/dto/triggerAction.dto';
import {RecipesTextComponent} from '../../../shared/components/modals/recipes-text/recipes-text.component';
import {CopyDiaryRecipesComponent} from '../modals/copy-diary-recipes/copy-diary-recipes.component';
import {MasterService} from '../../../shared/services/master.service';
import {DeleteDiaryRecipesComponent} from '../modals/delete-diary-recipes/delete-diary-recipes.component';
import {CateringOrderRecipesComponent} from '../modals/catering-order-recipes/catering-order-recipes.component';
import {CopyDiaryRecipesAdvancedComponent} from '../modals/copy-diary-recipes-advanced/copy-diary-recipes-advanced.component';

declare const require: (path: string) => object;

@Component({
    selector: 'app-meals',
    templateUrl: './meals.component.html',
    styleUrls: ['./meals.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MealsComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild('chat') private chat: ElementRef;
    @ViewChild('mealsChangeSwal') mealsChangeSwal: SwalComponent;
    @ViewChildren('activeCheck') activeChecks: QueryList<NgbTooltip>;
    @ViewChild('datepicker') datepicker: ElementRef<DatepickerComponent>;

    @Input() isMasterProfile: boolean;

    dailyMeals: DailyMealViewModel[];
    cateringUserMeals: CateringUserViewModel[];
    diets: DietViewModel[];
    diary: DiaryViewModel;
    date: string;
    dateObj: Date = new Date();
    recipesByMeal: { [key: number]: DiaryRecipeViewModel[] } = {};
    eatenMeals: { [key: number]: boolean } = {};
    diaryMacros: CalculationsViewModel = {
        overwrite_daily_meal_id: null,
        calories: 0,
        carbs: 0,
        fat: 0,
        protein: 0
    };
    userCalculations: CalculationsViewModel = {
        overwrite_daily_meal_id: null,
        calories: 0,
        carbs: 0,
        fat: 0,
        protein: 0
    };
    userProfile: UserProfileViewModel;
    currentlySelectedDailyMeal: DailyMealViewModel;
    bsModalRef: BsModalRef;
    currentlySelectedDiet: DietViewModel;
    defaultDiet: DietViewModel = {
        title: this.localisationService.localise('no_diet_chosen')
    };
    caloriesLeftByMeal: { [key: number]: number } = {};
    mealsSwiperConfig: SwiperConfigInterface;
    mobileActionsSwiperConfig: SwiperConfigInterface;
    activeDailyMealIndex: number;
    activeDietIndex: number;
    externalRecipes: ExternalMealViewModel[] = [];
    externalRecipesByMeal = {};

    productsNutrients: ProductNutrientViewModel[];
    diaryNutrientsByNutrientId: { [key: number]: DiaryNutrientViewModel } = {};

    preventLoadingFromStop = false;
    allowSwipingToNotEatenMeal = true;

    isFreePlan = false;

    subscriptions: Subscription[] = [];
    triggerActionEvent: TriggerActionDto = null;

    diaryLoaded = false;
    diaryMacrosLoaded = false;
    userProfileLoaded = false;
    userCalculationsLoaded = false;
    dailyMealsLoaded = false;
    isFreePlanLoaded = false;
    dietsLoaded = false;
    initCurrentlySelectedLoaded = false;
    initRecipesLoaded = false;
    initExternalMealsLoaded = false;
    initProductNutrientsLoaded = false;
    initDiaryNutrientsLoaded = false;

    chatMessage = '';
    chatMessages: DiaryChatMessage[] = [];
    isChatEnabled = false;
    isUserMasterReady = false;
    hideAutoLoadRecipes = false;
    dateChangeDisabled = false;

    motivationQuotes: object;
    motivationQuote = '';

    constructor(
        public readonly themeService: ThemeService,
        private readonly usersService: UsersService,
        private readonly changeDetectorRef: ChangeDetectorRef,
        private readonly bsModalService: BsModalService,
        private readonly bsModalEventsEmitter: BsModalEventsEmitter,
        private readonly diaryService: DiaryService,
        private readonly masterService: MasterService,
        private readonly localisationService: LocalisationService,
        private readonly dateService: DateService,
        private readonly storageService: StorageService,
        private readonly productsService: ProductsService,
        private readonly pricingService: PricingService,
        private readonly appLoadingEventsEmitter: AppLoadingEventsEmitter,
        readonly constants: Constants,
        private readonly router: Router,
        private readonly triggerActionEventsEmitter: TriggerActionEventsEmitter,
        @Inject(SWIPER_CONFIG) private readonly swiperConfig: SwiperConfigInterface
    ) {
        this.generateQuote();

        if (!this.isMasterProfile) {
            this.isMasterProfile = false;
        }

        this.subscriptions.push(
            this.triggerActionEventsEmitter.triggerActionObservable$.subscribe(change => {
                // this.triggerActionEvent = change;

                const interval = setInterval(() => {
                    console.log('check for load');

                    if (this.diaryLoaded
                        && this.diaryMacrosLoaded
                        && this.userProfileLoaded
                        && this.userCalculationsLoaded
                        && this.dailyMealsLoaded
                        && this.isFreePlanLoaded
                        && this.dietsLoaded
                        && this.initCurrentlySelectedLoaded
                        && this.initRecipesLoaded
                        && this.initExternalMealsLoaded
                        && this.initProductNutrientsLoaded
                        && this.initDiaryNutrientsLoaded) {
                        clearInterval(interval);

                        if (change.action === 'meal') {
                            this.openChooseCategoryModal(change.data['meal']);
                        } else if (change.action === 'external_meals') {
                            this.openExternalMealsModal();
                        } else if (change.action === 'shopping_list') {
                            this.openShoppingListModal();
                        } else if (change.action === 'recipes_text') {
                            this.openRecipesTextModal();
                        } else if (change.action === 'diary_training') {
                            this.openDiaryTrainingModal();
                        } else if (change.action === 'daily_changes_activities') {
                            this.openDailyChangesActivitiesModal();
                        } else if (change.action === 'load_recipes') {
                            this.onLoadRandomRecipes();
                        }
                    }
                }, 200);


            }));
    }

    generateQuote() {
        try {
            if (this.storageService.getItem('hide_motivation_quote') === 'true' && moment().format('YYYY-MM-DD') === this.storageService.getItem('hide_motivation_quote_date')) {
                return;
            }

            if (!this.storageService.getItem('motivation_quote') || moment().format('YYYY-MM-DD') !== this.storageService.getItem('motivation_quote_date')) {
                this.motivationQuotes = require(`../../../../../../config/motivation_quotes.json`);
                // @ts-ignore
                const motivationIndex = Math.ceil(Math.random() * this.motivationQuotes.length);
                this.motivationQuote = this.motivationQuotes[motivationIndex][this.localisationService.getLanguage().toLowerCase()];
                this.storageService.setItem('motivation_quote', this.motivationQuote);
                this.storageService.setItem('motivation_quote_date', moment().format('YYYY-MM-DD'));
            }

            this.motivationQuote = this.storageService.getItem('motivation_quote');
        } catch (e) {
        }
    }

    hideQuote() {
        this.storageService.setItem('hide_motivation_quote', 'true');
        this.storageService.setItem('hide_motivation_quote_date', moment().format('YYYY-MM-DD'));
        this.motivationQuote = '';
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    ngOnInit() {
        this.date = this.dateService.getDate();
        this.mealsSwiperConfig = Object.assign({}, this.swiperConfig, {
            slidesPerView: 1.2,
            // slidesPerView: 'auto',
            // width: 80,
            // spaceBetween: 30,
        } as SwiperConfigInterface);

        this.mobileActionsSwiperConfig = Object.assign({}, this.swiperConfig, {
            slidesPerView: 4,
            spaceBetween: 12,
            freeMode: true,
        } as SwiperConfigInterface);

        this.init().subscribe();
    }

    ngAfterViewInit() {
        this.changeDetectorRef.detectChanges();

        this.loadFirstTimeHelpAnimation();
    }

    isMobileDevice(): boolean {
        return window.innerWidth <= 576;
    }

    openExternalMealsModal() {
        const openModal = () => {
            this.bsModalRef = this.bsModalService.show(ExternalMealsComponent, {
                backdrop: true
            });

            this.bsModalRef.content.mealsComponent = this;

            this.bsModalEventsEmitter.broadcastBsModalStateChanged(this.bsModalRef);
        };

        this.pricingService
            .isPermissionAllowed(this.pricingService.permissions['EXTERNAL_MEALS'])
            .subscribe(isAllowed => {
                if (isAllowed === false) {
                    this.openUpgradeModal();
                    this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
                    this.preventLoadingFromStop = false;
                } else {

                    if (!this.diary) {
                        this.createDiary().subscribe(() => {
                            openModal();
                        });
                    } else {
                        openModal();
                    }
                }
            });
    }

    openChooseCategoryModal(meal: MealViewModel) {
        const openModal = () => {
            this.bsModalRef = this.bsModalService.show(AddRecipeModalComponent, {
                backdrop: true
            });

            console.log(meal);

            this.bsModalRef.content.mealsComponent = this;
            this.bsModalRef.content.meal = meal;

            this.bsModalEventsEmitter.broadcastBsModalStateChanged(this.bsModalRef);
        };

        openModal();
    }

    openShoppingListModal() {
        const openModal = () => {
            this.bsModalRef = this.bsModalService.show(ShoppingListComponent, {
                backdrop: true
            });

            this.bsModalRef.content.date = this.date;

            this.bsModalEventsEmitter.broadcastBsModalStateChanged(this.bsModalRef);
        };

        openModal();
    }

    openRecipesTextModal() {
        const openModal = () => {
            this.bsModalRef = this.bsModalService.show(RecipesTextComponent, {
                backdrop: true
            });

            this.bsModalRef.content.dateObj = this.dateObj;

            this.bsModalEventsEmitter.broadcastBsModalStateChanged(this.bsModalRef);
        };

        openModal();
    }

    onRemoveRecipe(meal: MealViewModel, recipe: RecipeViewModel) {
        if (this.eatenMeals[meal.id]) {
            return;
        }

        this.diaryService
            .removeRecipeFromDiary({
                diary_recipe: this.diary.diary_recipes.find(dr => dr.meal.id === meal.id && dr.recipe.id === recipe.id).id
            })
            .subscribe(() => {
                this.clearShoppingList().subscribe(response => {
                    this.allowSwipingToNotEatenMeal = false;
                    this.init().subscribe(() => {
                        this.allowSwipingToNotEatenMeal = true;
                    });
                });
            });
    }

    onViewRecipe(recipe: DiaryRecipeViewModel) {
        this.bsModalRef = this.bsModalService.show(ViewRecipeComponent, {
            backdrop: true
        });

        this.bsModalRef.content.diaryRecipe = recipe;
        this.bsModalRef.content.mealsComponent = this;

        this.bsModalEventsEmitter.broadcastBsModalStateChanged(this.bsModalRef);
    }

    onDateChanged(date: Date) {
        this.dateObj = date;
        this.date = this.dateService.getDate(date);
        this.init().subscribe();
    }

    onDatePickerChanged(date: Date) {
        if (this.dateChangeDisabled === true) {
            return;
        }

        this.dateChangeDisabled = true;
        this.dateObj = date;
        this.date = this.dateService.getDate(date);
        this.init().subscribe(() => {
            this.dateChangeDisabled = false;
        });
    }

    onDateForwards() {
        this.dateObj = this.dateService.dayForwards(this.dateObj);
        // this.onDateChanged(this.dateObj);
    }

    onDateBackwards() {
        this.dateObj = this.dateService.dayBackwards(this.dateObj);
        // this.onDateChanged(this.dateObj);
    }

    onMarkMealAsEaten(meal: MealViewModel) {
        this.appLoadingEventsEmitter.broadcastAppIsLoading(true);

        this.diaryService
            .markDiaryMealAsEaten({
                date: this.date,
                is_eaten: !this.eatenMeals[meal.id],
                meal: meal.id
            })
            .subscribe(() => {
                this.init().subscribe();
            });
    }

    round(number: number): number {
        return Math.round(number);
    }

    onLoadRandomRecipes() {
        const loadDiaryRecipes = () => {
            this.diaryService.loadRecipes({date: this.date})
                .subscribe(() => {
                    this.init().subscribe(() => {
                        this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
                    });
                }, () => {
                    this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
                });
        };

        this.appLoadingEventsEmitter.broadcastAppIsLoading(true);

        if (this.diary) {
            loadDiaryRecipes();
        } else {
            this.createDiary().subscribe(() => {
                loadDiaryRecipes();
            });
        }
    }

    get userDailyMeals(): DailyMealViewModel {
        return this.currentlySelectedDailyMeal ? this.currentlySelectedDailyMeal : this.usersService.userProfile.daily_meals;
    }

    get mealCardsClasses(): string {
        if (!this.userDailyMeals) {
            return;
        }

        const shared = 'column mobile-full';

        // return the proper bootstrap classes based on the meals count
        switch (this.userDailyMeals.meals.length) {
            case 2:
                return `${shared} half`;
            case 3:
                return `${shared} third`;
            case 4:
                return `${shared} fourth`;
            case 5:
                return `${shared} fifth`;
        }
    }

    get orderedUserDailyMeals(): MealViewModel[] {
        if (!this.userDailyMeals) {
            return [];
        }

        return this.userDailyMeals.meals.sort((a, b) => a.sort - b.sort);
    }

    get day(): string {
        switch (this.dateObj.getDay()) {
            case 0:
                return 'sunday';
            case 1:
                return 'monday';
            case 2:
                return 'tuesday';
            case 3:
                return 'wednesday';
            case 4:
                return 'thursday';
            case 5:
                return 'friday';
            case 6:
                return 'saturday';
        }
    }

    private activeMealIndex() {
        if (!this.eatenMeals) {
            return 0;
        }

        return Object.keys(this.eatenMeals).findIndex(k => !this.eatenMeals[k]);
    }

    private initCurrentlySelected() {
        if (this.diary) {
            // a diary is always created with daily_meals so it should always be present
            this.currentlySelectedDailyMeal = this.dailyMeals.find(dm => dm.id === this.diary.daily_meals.id);
            this.activeDailyMealIndex = this.dailyMeals.findIndex(dm => dm.id === this.currentlySelectedDailyMeal.id);

            // diary.diet may or may not be present, thats why we need to check it up
            if (this.diary.diet) {
                this.currentlySelectedDiet = this.diets.find(d => d.id === this.diary.diet.id);
            }

            if (!this.currentlySelectedDiet) {
                this.currentlySelectedDiet = this.defaultDiet;
            }

            if (this.currentlySelectedDiet && this.currentlySelectedDiet !== this.defaultDiet) {
                this.activeDietIndex = this.diets.findIndex(d => d.id === this.currentlySelectedDiet.id) - 1;
            } else {
                this.activeDietIndex = undefined;
            }

            this.initCurrentlySelectedLoaded = true;
            this.changeDetectorRef.detectChanges();

            return;
        }

        // if there is no diary we get the default daily_meals and diet, selected in the wizard earlier
        const {
            userProfile: {daily_meals, diet}
        } = this.usersService;

        if (this.userCalculations && this.userCalculations.overwrite_daily_meal_id > 0) {
            this.currentlySelectedDailyMeal = daily_meals ?
                this.dailyMeals.find(dm => dm.id === this.userCalculations.overwrite_daily_meal_id)
                : undefined;
        } else {
            this.currentlySelectedDailyMeal = daily_meals ? this.dailyMeals.find(dm => dm.id === daily_meals.id) : undefined;
        }

        this.activeDailyMealIndex = this.dailyMeals.findIndex(dm => dm.id === this.currentlySelectedDailyMeal.id);

        if (diet) {
            this.currentlySelectedDiet = this.diets.find(d => d.id === diet.id);
            this.activeDietIndex = this.diets.findIndex(d => d.id === this.currentlySelectedDiet.id) - 1;
        }

        this.initCurrentlySelectedLoaded = true;
        this.changeDetectorRef.detectChanges();
    }

    private initRecipes() {
        if (!this.userDailyMeals) {
            this.initRecipesLoaded = true;
            return;
        }

        this.userDailyMeals.meals.forEach(meal => {
            if (this.diary) {
                this.recipesByMeal[meal.id] = this.diary.diary_recipes.filter(dr => dr.meal.id === meal.id);
                this.eatenMeals[meal.id] = !!this.diary.diary_recipes.filter(dr => dr.meal.id === meal.id).find(r => r.is_eaten);
            } else {
                this.recipesByMeal[meal.id] = [];
                this.eatenMeals[meal.id] = false;
            }
        });

        this.makeRecipesTitleHeightEquals();

        if (this.allowSwipingToNotEatenMeal === true) {
            this.swipeToActiveMeal();
        }

        this.initRecipesLoaded = true;

        this.changeDetectorRef.detectChanges();
    }

    private swipeToActiveMeal() {
        if (document.querySelector('.meals-swiper .swiper-container')) {
            const swiper = document.querySelector('.meals-swiper .swiper-container')['swiper'];
            // @ts-ignore
            swiper.slideTo(this.activeMealIndex(), 800);
        }

    }

    private makeRecipesTitleHeightEquals() {
        setTimeout(() => {
            const recipeTitles = document.getElementsByClassName('recipe-title');
            let maxHeight = 0;

            for (let i = 0; i < recipeTitles.length; i++) {
                if (recipeTitles[i].clientHeight > maxHeight) {
                    maxHeight = recipeTitles[i].clientHeight;
                }
            }

            for (let i = 0; i < recipeTitles.length; i++) {
                // @ts-ignore
                recipeTitles[i].style.height = maxHeight + 'px';
            }
        }, 300);
    }

    public createDiary(
        createDiaryDTO: CreateDiaryDTO = {
            daily_meals: this.userDailyMeals.id,
            diet: this.usersService.userProfile.diet ? this.usersService.userProfile.diet.id : null
        }
    ): Observable<boolean> {
        return new Observable((observer: Observer<boolean>) => {
            this.diaryService.createDiary(this.date, createDiaryDTO).subscribe(() => {
                this.init().subscribe(() => {
                    observer.next(true);
                    observer.complete();
                });
            });
        });
    }

    private initCaloriesLeftByMeal() {
        forkJoin(
            this.currentlySelectedDailyMeal.meals.map(m =>
                this.diaryService.getMealLeftCalories({
                    date: this.date,
                    meal: m.id
                })
            )
        ).subscribe(getMealLeftCaloriesDTOs => {
            this.currentlySelectedDailyMeal.meals.forEach((m, i) => {
                this.caloriesLeftByMeal[m.id] = getMealLeftCaloriesDTOs[i].left_calories;
            });

            this.changeDetectorRef.detectChanges();
        });
    }

    showWarning(): Boolean {
        // tslint:disable-next-line:forin
        for (const mealIndex in this.orderedUserDailyMeals) {
            const meal = this.orderedUserDailyMeals[mealIndex];

            if (this.caloriesLeftByMeal[meal.id] > meal.warning_after_kcal) {
                return true;
            }
        }

        return false;
    }

    getNextSuggestedDailyMeals(): DailyMealViewModel {
        if (!this.showWarning()) {
            return null;
        }

        // tslint:disable-next-line:forin
        for (const dailyMealIndex in this.dailyMeals.sort((a, b) => a.id - b.id)) {
            const dailyMeal = this.dailyMeals[dailyMealIndex];

            if (dailyMeal.id > this.currentlySelectedDailyMeal.id) {
                return dailyMeal;
            }
        }

        return null;
    }

    warningCallback(callbackParent) {
        const nextDailyMeal = callbackParent.getNextSuggestedDailyMeals();

        callbackParent.changeDailyMeals(nextDailyMeal);
    }

    changeDailyMeals(dailyMeal: DailyMealViewModel) {
        const changeDailyMeal = () => {
            this.diaryService
                .updateDiary(this.date, {
                    daily_meals: {
                        id: dailyMeal.id
                    }
                })
                .subscribe(() => {
                    this.usersService
                        .updateUserProfile({
                            daily_meals: {
                                id: dailyMeal.id
                            },
                        })
                        .subscribe(() => {
                            this.init().subscribe();
                        });
                });
        };

        if (this.diary) {
            changeDailyMeal();
        } else {
            this.createDiary().subscribe(() => {
                changeDailyMeal();
            });
        }
    }

    isMealDisabledForEdit(mealId: number) {
        if (this.cateringUserMeals && this.cateringUserMeals.length > 0) {
            return this.cateringUserMeals.find(c => c.meal === mealId);
        }

        return false;
    }

    private loadFirstTimeHelpAnimation() {
        if (this.isMobileDevice()) {
            // run only first time on mobile device
            if (this.storageService.getItem('meals-animation-on-mobile') !== null) {
                return;
            }

            // animation
            const _this = this;
            const interval = setInterval(function () {
                if (_this.appLoadingEventsEmitter.isAppLoading() === false) {
                    setTimeout(function () {
                        if (document.querySelector('.meals-swiper .swiper-container')) {
                            const mealsSwiper = document.querySelector('.meals-swiper .swiper-container')['swiper'];
                            _this.troughSwiperElementsNext(mealsSwiper);
                        }
                    }, 1000);

                    clearInterval(interval);
                }
            }, 50);
        }
    }

    private troughSwiperElementsNext(swiper) {
        const _this = this;

        if (swiper.slideNext(1500) === false) {
            swiper.slideTo(0, 2500);

            this.storageService.setItem('meals-animation-on-mobile', 'true');

            return;
        }

        setTimeout(function () {
            _this.troughSwiperElementsNext(swiper);
        }, 1700);
    }

    calculatePercentage(current: number, total: number): number {
        return (current / total) * 100;
    }

    init(): Observable<boolean> {
        console.log('call init');

        const stopLoading = () => {
            if (this.preventLoadingFromStop === false) {
                this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
                this.changeDetectorRef.detectChanges();
            }
        };

        const initInternal = (): Observable<boolean> => {
            return new Observable((observer: Observer<boolean>) => {
                forkJoin(
                    this.diaryService.getUserMacros(this.date),
                    this.usersService.getUserDailyMeals(),
                    this.usersService.getUserDiets(),
                    this.usersService.getUserCateringMeals(),
                    this.pricingService.isFreePlan()
                ).subscribe(
                    ([userCalculations, dailyMeals, diets, cateringUserMeals, isFreePlan]) => {
                        this.userCalculations = userCalculations;
                        this.dailyMeals = dailyMeals;
                        this.isFreePlan = isFreePlan;
                        this.cateringUserMeals = cateringUserMeals;
                        this.diets = [this.defaultDiet, ...diets];
                        this.changeDetectorRef.detectChanges();

                        this.loadChatMessage();
                        this.initCurrentlySelected();
                        this.initRecipes();
                        this.initExternalRecipes();
                        this.initNutrients();
                        this.openAllTooltips();

                        this.userProfileLoaded = true;
                        this.userCalculationsLoaded = true;
                        this.dailyMealsLoaded = true;
                        this.isFreePlanLoaded = true;
                        this.dietsLoaded = true;

                        initDiaryMacros().subscribe();

                        this.changeDetectorRef.detectChanges();
                        observer.next(true);
                        observer.complete();

                    }
                );
            });
        };

        const initDiaryMacros = (): Observable<boolean> => {
            return new Observable((observer: Observer<boolean>) => {
                this.diaryService.getDiaryMacros(this.date).subscribe(
                    diaryMacros => {
                        this.diaryMacros = {
                            overwrite_daily_meal_id: diaryMacros.overwrite_daily_meal_id,
                            calories: Math.round(diaryMacros.calories),
                            carbs: Math.round(diaryMacros.carbs),
                            fat: Math.round(diaryMacros.fat),
                            protein: Math.round(diaryMacros.protein)
                        };
                        this.changeDetectorRef.detectChanges();

                        this.initCaloriesLeftByMeal();
                        stopLoading();

                        this.diaryMacrosLoaded = true;

                        observer.next(true);
                        observer.complete();
                    },
                    () => {
                        this.diaryMacros = {
                            overwrite_daily_meal_id: null,
                            calories: 0,
                            carbs: 0,
                            fat: 0,
                            protein: 0
                        };
                        this.changeDetectorRef.detectChanges();

                        this.initCaloriesLeftByMeal();
                        stopLoading();

                        this.diaryMacrosLoaded = true;

                        observer.next(true);
                        observer.complete();
                    }
                );
            });
        };

        return new Observable((observer: Observer<boolean>) => {
            this.appLoadingEventsEmitter.broadcastAppIsLoading(true);

            this.usersService.getUserProfile().subscribe(userProfile => {
                this.userProfile = userProfile;
                this.hideAutoLoadRecipes = userProfile.hide_auto_load_button;
                this.changeDetectorRef.detectChanges();

                this.diaryService.getDiary(this.userProfile.id, this.date).subscribe(diary => {
                        this.diary = diary;
                        this.diaryLoaded = true;
                        this.changeDetectorRef.detectChanges();

                        initInternal().subscribe(() => {
                            observer.next(true);
                            observer.complete();
                        });
                    },
                    () => {
                        this.diaryLoaded = true;
                        this.diary = undefined;

                        initInternal().subscribe(() => {
                            observer.next(true);
                            observer.complete();
                        });
                    }
                );
            });
        });
    }

    private initExternalRecipes() {
        this.diaryService.getDiaryExternalRecipes(this.date).subscribe(externalRecipes => {
            this.externalRecipes = externalRecipes;

            this.externalRecipesByMeal = {};

            // tslint:disable-next-line:forin
            for (const index in this.externalRecipes) {
                if (!this.externalRecipes[index].diary_meal) {
                    continue;
                }

                if (typeof this.externalRecipesByMeal[this.externalRecipes[index].diary_meal.id] === 'undefined') {
                    this.externalRecipesByMeal[this.externalRecipes[index].diary_meal.id] = [];
                }

                this.externalRecipesByMeal[this.externalRecipes[index].diary_meal.id].push(this.externalRecipes[index]);
            }

            this.initExternalMealsLoaded = true;
            this.changeDetectorRef.detectChanges();

        }, () => {
            this.externalRecipesByMeal = {};
            this.externalRecipes = [];

            this.initExternalMealsLoaded = true;
            this.changeDetectorRef.detectChanges();
        });
    }

    private openAllTooltips() {
        setTimeout(() => {
            this.activeChecks.forEach((tooltip) => {
                tooltip.open();
            });
        }, 1000);
    }

    private clearShoppingList() {
        const date = new Date();
        const monday = new Date(date.setDate((date.getDate() - date.getDay() + (date.getDay() === 0 ? -6 : 1))));
        const sunday = new Date(date.setDate(date.getDate() - date.getDay() + ((date.getDay() === 0 ? -6 : 1)) + 6));

        return this.diaryService.clearShoppingItems(moment(monday).format('YYYY-MM-DD'), moment(sunday).format('YYYY-MM-DD'));
    }

    private initNutrients() {
        this.productsService.getProductsNutrients().subscribe(
            productsNutrients => {
                this.productsNutrients = productsNutrients;
                this.initProductNutrientsLoaded = true;

                this.initDiaryNutrients();
            },
            () => {
                this.initProductNutrientsLoaded = true;

                if (this.preventLoadingFromStop === false) {
                    this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
                }
            }
        );
    }

    private initDiaryNutrients() {
        this.diaryService.getDiaryNutrients(this.date).subscribe(
            diaryNutrients => {
                this.diaryNutrientsByNutrientId = this.productsNutrients
                    .map(pn => pn.macro.id)
                    .reduce((p, c) => {
                        p[c] = diaryNutrients[c];

                        return p;
                    }, {});

                this.initDiaryNutrientsLoaded = true;
                this.changeDetectorRef.detectChanges();

                if (this.preventLoadingFromStop === false) {
                    this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
                }
            },
            () => {
                this.diaryNutrientsByNutrientId = {};
                this.initDiaryNutrientsLoaded = true;

                this.changeDetectorRef.detectChanges();

                if (this.preventLoadingFromStop === false) {
                    this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
                }
            }
        );
    }

    floor(number: number) {
        return Math.floor(number);
    }

    private getSvg(svg: string): string {
        // if (this.themeService.getCurrentTheme() !== 'light') {
        svg += '-white';
        // }

        return `assets/images/macros/${svg}.svg`;
    }

    openUpgradeModal() {
        this.bsModalRef = this.bsModalService.show(UpgradeComponent, {
            backdrop: true
        });

        this.bsModalEventsEmitter.broadcastBsModalStateChanged(this.bsModalRef);
    }

    toPricing() {
        this.router.navigate(['pricing']);
        this.bsModalRef.hide();
    }

    openCopyModal(diaryRecipe: DiaryRecipeViewModel) {
        this.bsModalRef = this.bsModalService.show(CopyRecipeComponent, {
            backdrop: true
        });

        this.bsModalRef.content.mealsComponent = this;
        this.bsModalRef.content.diaryRecipe = diaryRecipe;

        this.bsModalEventsEmitter.broadcastBsModalStateChanged(this.bsModalRef);
    }

    openCopyDiaryRecipesModal() {
        this.bsModalRef = this.bsModalService.show(CopyDiaryRecipesComponent, {
            backdrop: true
        });

        this.bsModalRef.content.mealsComponent = this;

        this.bsModalEventsEmitter.broadcastBsModalStateChanged(this.bsModalRef);
    }

    openCopyDiaryRecipesAdvancedModal() {
        this.bsModalRef = this.bsModalService.show(CopyDiaryRecipesAdvancedComponent, {
            backdrop: true
        });

        this.bsModalRef.content.mealsComponent = this;

        this.bsModalEventsEmitter.broadcastBsModalStateChanged(this.bsModalRef);
    }

    openCateringOrdersModal() {
        this.bsModalRef = this.bsModalService.show(CateringOrderRecipesComponent, {
            backdrop: true
        });

        this.bsModalRef.content.mealsComponent = this;

        this.bsModalEventsEmitter.broadcastBsModalStateChanged(this.bsModalRef);
    }

    openDiaryTrainingModal() {
        this.bsModalRef = this.bsModalService.show(DiaryTrainingComponent, {
            backdrop: true
        });

        this.bsModalRef.content.mealsComponent = this;

        this.bsModalEventsEmitter.broadcastBsModalStateChanged(this.bsModalRef);
    }

    openDailyChangesActivitiesModal() {
        this.bsModalRef = this.bsModalService.show(DailyChangesActivitiesComponent, {
            backdrop: true
        });

        this.bsModalRef.content.mealsComponent = this;

        this.bsModalEventsEmitter.broadcastBsModalStateChanged(this.bsModalRef);
    }

    linkClickable(text) {
        const urlRegex = /(https?:\/\/[^\s]+)/g; // regex for both http:// and https://
        return text.replace(urlRegex, function (url) {
            return '<a href="' + url + '" target="_blank">линк</a>'; // return the replaced text
        });
    }

    loadChatMessage() {
        forkJoin(
            this.masterService.checkIsSubAccountUnderMaster(),
            this.diaryService.getUserIsMasterReady()
        ).subscribe(([success, isMasterReady]) => {
            this.isUserMasterReady = isMasterReady.ready;
            this.isChatEnabled = true;

            this.diaryService.getChatMessages(this.userProfile.id).subscribe(data => {
                const messages = data.messages;

                for (let i = 0; i < messages.length; i++) {
                    messages[i].message = this.linkClickable(messages[i].message);
                }

                this.chatMessages = messages;
                this.changeDetectorRef.detectChanges();

                if (this.chat) {
                    setTimeout(() => {
                        this.chat.nativeElement.scrollTop = 999999999999999;
                    }, 500);
                }
                this.changeDetectorRef.detectChanges();
            });
        }, () => {
            this.isChatEnabled = false;
            this.isUserMasterReady = false;
        });
    }

    sendMessage() {
        this.diaryService.postChatMessages(this.userProfile.id, this.chatMessage).subscribe(() => {
            this.chatMessage = '';
            this.changeDetectorRef.detectChanges();

            this.loadChatMessage();
        });
    }

    openDeleteDiaryRecipesModal() {
        this.bsModalRef = this.bsModalService.show(DeleteDiaryRecipesComponent, {
            backdrop: true
        });

        this.bsModalRef.content.mealsComponent = this;

        this.bsModalEventsEmitter.broadcastBsModalStateChanged(this.bsModalRef);
    }

    formatCreatedTime(date) {
        return moment(date).format('HH:mm ч. / DD.MM.YYYY');
    }

    loadPreviousRecipe(mealId) {
        if (confirm('Сигурни ли сте, че искате да заредите предишната рецепта?')) {
            this.appLoadingEventsEmitter.broadcastAppIsLoading(true);

            this.diaryService.getDiaryPassedRecipes(this.diary.id).subscribe(passedRecipesData => {
                const passedRecipes = passedRecipesData.filter(recipe => recipe.mealId === mealId);
                const latestPassedRecipe = passedRecipes.length > 0 ? passedRecipes[0] : null;

                if (latestPassedRecipe != null) {
                    const newProducts = [];

                    latestPassedRecipe.products.forEach(product => {
                        newProducts.push({
                            'product_id': product.productId,
                            'qty': product.qty,
                            'weight': product.weight,
                        });
                    });

                    const recipesToDelete = this.diary.diary_recipes.filter(dr => dr.meal.id === mealId);
                    const deleteRequests = [];

                    for (const recipe of recipesToDelete) {
                        deleteRequests.push(this.diaryService.removeRecipeFromDiary({diary_recipe: recipe.id}));
                    }

                    const _this = this;
                    const finalRequest = function () {
                        _this.clearShoppingList().subscribe(response => {
                            _this.appLoadingEventsEmitter.broadcastAppIsLoading(true);

                            _this.diaryService.addRecipeToDiary({
                                date: _this.date,
                                meal: mealId,
                                recipe: latestPassedRecipe.recipeId,
                                products: newProducts
                            }).subscribe(() => {
                                _this.diaryService.removeRecipeFromDiaryPassed({
                                    diary_id: _this.diary.id,
                                    meal_id: mealId
                                }).subscribe(() => {
                                    _this.init().subscribe();
                                });
                            });
                        });
                    };

                    if (deleteRequests.length > 0) {
                        forkJoin(deleteRequests).subscribe(() => {
                            finalRequest();
                        });
                    } else {
                        finalRequest();
                    }
                } else {
                    this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
                }
            });
        }
    }

    loadNextRecipe(mealId) {
        if (confirm('Сигурни ли сте, че искате да смените текущата рецепта?')) {
            this.appLoadingEventsEmitter.broadcastAppIsLoading(true);

            const recipesDto = {
                date: this.date,
                meal: mealId,
                search_text: null,
                category: 1, // основни
                left_calories: this.findLeftCaloriesForMeal(mealId),
                attributes: null,
                meal_prep_friendly: null,
                has_video: false,
                selectedGlobalCategories: [],
                lang: this.localisationService.getLanguage(),
                user_id: this.userProfile.id
            };

            forkJoin([
                this.diaryService.getNewRecipes(recipesDto),
                this.diaryService.getDiaryPassedRecipes(this.diary.id)
            ]).subscribe(([recipes, passedRecipes]) => {
                const passedRecipeIds = new Set(
                    passedRecipes
                        .filter(recipe => recipe.mealId === mealId)
                        .map(recipe => recipe.recipeId)
                );

                const currentMealRecipe = this.recipesByMeal[mealId] && this.recipesByMeal[mealId].length > 0 ? this.recipesByMeal[mealId][0] : null;
                const currentMealRecipeProducts = currentMealRecipe != null ? currentMealRecipe.diary_products.map(product => ({
                    productId: product.product.id,
                    qty: product.qty,
                    weight: parseFloat(product.weight)
                })) : [];

                const availableRecipes = recipes.filter(recipe => !passedRecipeIds.has(recipe.id) && recipe.id != currentMealRecipe.recipe.id);

                console.log(this.recipesByMeal[mealId][0]);

                if (availableRecipes.length > 0) {
                    const randomRecipe = availableRecipes[Math.floor(Math.random() * availableRecipes.length)];
                    const newProducts = [];

                    randomRecipe['products'].forEach(product => {
                        newProducts.push({
                            'product_id': product['id'],
                            'qty': product['qty'],
                            'weight': product['weight'],
                        });
                    });

                    const recipesToDelete = this.diary.diary_recipes.filter(dr => dr.meal.id === mealId);
                    const deleteRequests = [];

                    for (const recipe of recipesToDelete) {
                        deleteRequests.push(this.diaryService.removeRecipeFromDiary({diary_recipe: recipe.id}));
                    }

                    const _this = this;
                    const finalRequest = function () {
                        _this.clearShoppingList().subscribe(response => {
                            _this.appLoadingEventsEmitter.broadcastAppIsLoading(true);

                            _this.diaryService.addRecipeToDiary({
                                date: _this.date,
                                meal: mealId,
                                recipe: randomRecipe.id,
                                products: newProducts
                            }).subscribe(() => {
                                if (currentMealRecipe.recipe.id) {
                                    _this.diaryService.addRecipeInDiaryPassed({
                                        diary_id: _this.diary.id,
                                        recipe_id: currentMealRecipe.recipe.id,
                                        meal_id: mealId,
                                        products: currentMealRecipeProducts
                                    }).subscribe(() => {
                                        _this.init().subscribe();
                                    });
                                } else {
                                    _this.init().subscribe();
                                }
                            });
                        });
                    };

                    if (deleteRequests.length > 0) {
                        forkJoin(deleteRequests).subscribe(() => {
                            finalRequest();
                        });
                    } else {
                        finalRequest();
                    }
                } else {
                    alert('Няма повече налични рецепти за този ден и хранене.');
                    this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
                }
            });
        }
    }

    private findLeftCaloriesForMeal(mealId) {
        if (this.caloriesLeftByMeal[mealId] !== undefined && this.caloriesLeftByMeal[mealId] > 20) {
            return this.caloriesLeftByMeal[mealId];
        }

        let calories = 0;
        for (const recipe of this.recipesByMeal[mealId]) {
            calories += this.floor(recipe.macros.calories);
        }
        return calories;
    }

}
